import { Tooltip, TooltipProps } from "@mui/material";

export const SMTooltip = ({ title, children }: TooltipProps) => {
  return <Tooltip {...{ title, children }} enterTouchDelay={0}></Tooltip>;
};
